import type { RegulatoryAlert, RegulatoryPolicy, NotificationCampaign } from '../../types/regulatory';

export const SEED_REGULATORY_ALERTS: RegulatoryAlert[] = [
  {
    id: 'reg-001',
    title: 'Washington MHMDA — Standalone CHD Privacy Policy Required',
    source: 'Washington AG Office',
    category: 'mhmda',
    urgency: 'critical',
    relevance: 97,
    published: '2026-02-10',
    summary:
      'MHMDA requires a standalone Consumer Health Data Privacy Policy. Lab upload data and AI-derived health inferences are covered. Private right of action.',
    affected_systems: ['chd_policy', 'consent_flows', 'data_deletion', 'data_storage'],
    status: 'in_pipeline',
    actions: [
      {
        type: 'policy_update',
        date: '2026-02-12',
        assignee: 'Stan',
        note: 'Privacy Policy v1.1 — add MHMDA disclosures',
        schedule: 'now',
        notifyCampaign: 'camp-001',
      },
      {
        type: 'consent_flow',
        date: '2026-02-12',
        assignee: 'Engineering',
        note: 'Wire opt-in consent before lab upload',
        schedule: 'scheduled',
      },
    ],
    reviewed_by: 'Stan',
    reviewed_date: '2026-02-11',
  },
  {
    id: 'reg-002',
    title: 'HIPAA BAA Required — CC Medical PHI Handoff',
    source: 'HHS HIPAA Newsroom',
    category: 'hipaa',
    urgency: 'critical',
    relevance: 95,
    published: '2026-02-08',
    summary:
      'Hemologix functions as a Business Associate of CC Medical PC. A signed BAA must be executed before any PHI flows.',
    affected_systems: ['baa', 'data_storage', 'rx_handoff', 'breach_notification'],
    status: 'reviewed',
    actions: [
      {
        type: 'vendor_baa',
        date: '2026-02-10',
        assignee: 'Legal',
        note: 'Draft BAA for CC Medical',
        schedule: 'legal_first',
      },
    ],
    reviewed_by: 'Stan',
    reviewed_date: '2026-02-09',
  },
  {
    id: 'reg-003',
    title: 'FDA CDS Software Exemption — Maintain Four Cures Act Criteria',
    source: 'FDA Digital Health Center',
    category: 'fda_ai',
    urgency: 'high',
    relevance: 88,
    published: '2026-02-05',
    summary:
      "FDA guidance on CDS software exemptions. Hemologix AI analysis qualifies if outputs are educational and don't replace clinical judgment.",
    affected_systems: ['ai_pipeline', 'privacy_policy', 'marketing'],
    status: 'reviewed',
    actions: [
      {
        type: 'legal_review',
        date: '2026-02-12',
        assignee: 'Legal',
        note: 'CDS exemption opinion',
        schedule: 'now',
      },
    ],
    reviewed_by: 'Stan',
    reviewed_date: '2026-02-12',
  },
  {
    id: 'reg-004',
    title: 'FTC Health Breach Notification Rule — Updated Requirements',
    source: 'Federal Register — FTC',
    category: 'ftc_enforcement',
    urgency: 'high',
    relevance: 84,
    published: '2026-01-28',
    summary:
      'Expanded coverage to health apps. 60-day notification requirement. Applies even with voluntary HIPAA compliance.',
    affected_systems: ['breach_notification', 'data_storage', 'admin_reporting'],
    status: 'in_pipeline',
    actions: [
      {
        type: 'code_update',
        date: '2026-02-10',
        assignee: 'Engineering',
        note: 'Build breach detection pipeline',
        schedule: 'scheduled',
      },
      {
        type: 'policy_update',
        date: '2026-02-10',
        assignee: 'Stan',
        note: 'Add breach notification procedures to Privacy Policy',
        schedule: 'scheduled',
        notifyCampaign: null,
      },
    ],
    reviewed_by: 'Stan',
    reviewed_date: '2026-02-05',
  },
  {
    id: 'reg-005',
    title: 'Connecticut CTDPA — Consumer Health Data Provisions',
    source: 'CT AG Office',
    category: 'state_privacy',
    urgency: 'medium',
    relevance: 72,
    published: '2026-01-15',
    summary:
      "Connecticut's data privacy act includes consumer health data protections. Consent requirements for health data processing.",
    affected_systems: ['consent_flows', 'privacy_policy'],
    status: 'new',
    actions: [],
    reviewed_by: null,
    reviewed_date: null,
  },
];

export const SEED_REGULATORY_POLICIES: RegulatoryPolicy[] = [
  {
    id: 'pol-tos',
    name: 'Terms of Service',
    currentVersion: '1.0.0',
    effectiveDate: '2025-02-13',
    lastUpdated: '2025-02-13',
    drafts: [],
    history: [
      { version: '1.0.0', date: '2025-02-13', tier: null, summary: 'Initial publication', status: 'live' },
    ],
  },
  {
    id: 'pol-privacy',
    name: 'Privacy Policy',
    currentVersion: '1.0.0',
    effectiveDate: '2025-02-13',
    lastUpdated: '2025-02-13',
    drafts: [],
    history: [
      { version: '1.0.0', date: '2025-02-13', tier: null, summary: 'Initial publication', status: 'live' },
    ],
  },
  {
    id: 'pol-chd',
    name: 'Consumer Health Data Policy',
    currentVersion: null,
    effectiveDate: null,
    lastUpdated: null,
    drafts: [],
    history: [],
  },
];

export const SEED_REGULATORY_CAMPAIGNS: NotificationCampaign[] = [
  {
    id: 'camp-001',
    policyId: 'pol-privacy',
    alertId: 'reg-001',
    version: '1.1.0',
    tier: 'material',
    methods: ['email', 'banner', 'reconsent'],
    status: 'draft',
    summary:
      'Adding MHMDA-compliant health data consent disclosures and 30-day deletion rights',
    changeSummary:
      '\u2022 Added Section 8A: Consumer Health Data Rights\n\u2022 Updated data sharing disclosures for pharmacy partners\n\u2022 Added 30-day deletion guarantee\n\u2022 New opt-in consent requirements for lab uploads',
    createdDate: '2026-02-12',
    notifyDate: null,
    effectiveDate: null,
    stats: { total: 0, notified: 0, acknowledged: 0, pending: 0 },
  },
];
